import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import { Form, Control } from 'react-redux-form';
import { addCommas } from '../../config/utils';
import DatePicker from 'react-datepicker';
import 'rc-slider/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import './FormWrapper.css';

export function FormWrapper (props) {
  return (
    <Form
      id="input-form"
      model="input"
      onSubmit={(input) => props.handleSubmit(input)}
    >
      <div className="form-group">
        <label htmlFor="startingAmount">Starting Amount ($)</label>
        <Control.text
          type="text" 
          model=".startingAmount" 
          min={0}
          parser={addCommas}
          id="startingAmount"
        />
      </div>
      <div className="form-group">
        <label htmlFor="startingAmount">Starting Date</label>
        <DatePicker
          model=".startingDate"
          id="startingDate"
          selected={props.input.startingDate}
          onChange={(value) => {props.updateControl('startingDate', value)}}
          filterDate={props.isWeekday}
          minDate={props.minDate}
          maxDate={props.maxDate}
          utcOffset={0}
          dateFormat="YYYY-MM-DD"
          showMonthDropdown
          showYearDropdown
          placeholderText="Select a weekday" />
      </div>
      <div className="form-group-2">
        <label htmlFor="stockAllocation">Stock (to Bond) Allocation (%)</label>
        <Control.text
          type="number" 
          model=".stockAllocation" 
          min={0}
          max={100}
          id="stockAllocation"
        />
        <div id="stockAllocationSlider" className="slider-wrapper">
          <Slider 
            min={0}
            max={100}
            value={props.input.stockAllocation}
            onChange={(value) => {props.updateControl('stockAllocation', value)}}
          />
        </div>
      </div>
      <div className="form-group-2">
        <label htmlFor="bitcoinPercentage">Bitcoin Allocation (%)</label>
        <Control.text 
          type="number" 
          model=".bitcoinPercentage"
          min={0}
          max={100}
          id="bitcoinPercentage"
        />
        <div id="bitcoinPercentage" className="slider-wrapper">
          <Slider
            min={0}
            max={100}
            value={props.input.bitcoinPercentage}
            onChange={(value) => {props.updateControl('bitcoinPercentage', value)}}
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="withRebalancing">50% Tolerance-based Rebalancing</label>
        <Control.checkbox 
          model=".withRebalancing"
          id="withRebalancing"
        />
      </div>
      <div className="infoDisplay">
        Stock {props.ratioStock}% / Bond {props.ratioBond}% / Bitcoin {props.ratioCrypto}%
      </div>
      <div className="buttonToolbar">
        <button type="submit" className="submit">{props.calculated ? "Re-calculate" : "Calculate"}</button>
      </div>
    </Form>
  )
}


// WEBPACK FOOTER //
// ./src/components/FormWrapper/FormWrapper.js